import type { DividendCashBreakdown } from '@hjci-investorhub-v2/shared';
import type { RecordItem } from './record-form';
export const dividendCash = (item: RecordItem) => item.cashBreakdown as DividendCashBreakdown | undefined;
export function dividendCashValue(item: RecordItem, key: string) {
  const cash = dividendCash(item);
  return cash && (key === 'expectedCashAmount' || key === 'frankingCredit') ? cash[key] : item[key];
}
